// extracted by mini-css-extract-plugin
export var orderSummary = "_o8-0";
export var showMoreLessButton = "_o8-1";